var React = require('react');

function Checkbox (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.699 12.946a1 1 0 0 1 0-1.409l.204-.205a1 1 0 0 1 1.418 0l2.683 2.696a1 1 0 0 0 1.42-.001l7.252-7.31a1 1 0 0 1 1.422.003l.208.211a1 1 0 0 1-.003 1.406l-8.879 8.948a1 1 0 0 1-1.42 0L4.7 12.946z","fill":"#fff"}));
}

Checkbox.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkbox;

Checkbox.default = Checkbox;
